import React from 'react';
import { Table } from 'react-bootstrap';
import { createClaimsTable } from './claimUtils';
import PropTypes from 'prop-types';

export const IdTokenData = (props) => {
  const tokenClaims = createClaimsTable(props.idTokenClaims);

  const tableRow = Object.keys(tokenClaims).map((key) => {
    return (
        <tr key={key}>
          {tokenClaims[key].map((claimItem) => (
            <td key={claimItem}>{claimItem}</td>
          ))}
        </tr>
      );
  });

  return (
    <>
      <div className="data-area-div">
        <p>
          See below the claims in your <strong> ID token </strong>. For more
          information, visit:{' '}
          <span>
            <a href="https://docs.microsoft.com/en-us/azure/active-directory/develop/id-tokens#claims-in-an-id-token">
              docs.microsoft.com
            </a>
          </span>
        </p>
        <div className="data-area-div">
          <Table responsive striped bordered hover>
            <thead>
              <tr>
                <th>Claim</th>
                <th>Value</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>{tableRow}</tbody>
          </Table>
        </div>
      </div>
    </>
  );
};

IdTokenData.propTypes = {
  idTokenClaims: PropTypes.array.isRequired
};
